// extracted by mini-css-extract-plugin
export default {"icon":"Resume_icon__WrTlS","resume":"Resume_resume__sSr2K"};